export const UPDATE_GROUP_LIST = 'UPDATE_GROUP_LIST';

export function updateGroupList(groupList) {
  return {
    type: UPDATE_GROUP_LIST,
    data: { groupList },
  };
}
